export default class AxiosInstance {
	constructor(axios) {
		this.axios = axios;
	}

	request = async (method, uri, extraParams = {}, formData = new FormData(), extraConfig = {}) => {
		let defaultHeaders = {};

		switch (method.toLocaleUpperCase()) {
			case 'GET':
				return this.axios.get(uri, {
					headers: defaultHeaders,
					params: extraParams,
					...extraConfig,
				});
			case 'POST':
				return this.axios.post(uri, formData, {
					headers: defaultHeaders,
					params: extraParams,
					...extraConfig,
				});
			case 'PUT':
				return this.axios.put(uri, formData, {
					headers: defaultHeaders,
					params: extraParams,
					...extraConfig,
				});
			case 'DELETE':
				return this.axios.delete(uri, {
					headers: defaultHeaders,
					params: extraParams,
					...extraConfig,
				});
			default:
				throw new Error('Request method not supported.');
		}
	};
}
